import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NoRolesDialogBodyComponent } from '../no-roles-dialog-body/no-roles-dialog-body.component';
import { AuthenticationService } from '../../../../authentication/authentication.service';

@Component({
    selector: 'app-no-roles-dialog',
    template: ''
})
export class NoRolesDialogComponent implements OnInit {
    dialogRef: MatDialogRef<NoRolesDialogBodyComponent>;

    constructor(private readonly authenticationService: AuthenticationService, public dialog: MatDialog) {}

    ngOnInit() {
        if (this.authenticationService.getUserRoles().length === 0) {
            this.openDialog();
        }
    }

    openDialog() {
        this.dialogRef = this.dialog.open(NoRolesDialogBodyComponent, {
            disableClose: true,
            closeOnNavigation: false,
            hasBackdrop: true
        });
    }

    closeDialog() {
        this.dialogRef?.close();
    }
}
